// extracted by mini-css-extract-plugin
export default {"container":"UniDetails_container__5PUCv","link":"UniDetails_link__hUOVR","icon":"UniDetails_icon__cyRYJ"};